var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30mm",
    height: "30mm",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.9522 -70.125)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.026458 0 0 .026444 -1.0447 70.397)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-logo",
    transform: "matrix(2.5558 0 0 2.5558 512 512)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.9467e-6 1.1413e-6)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.32619 0 0 -.32619 -56.243 -21.966)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1507.7 -4409.1)",
    d: "m1646.3 4084.2-432.37 424.99c-5 4.91-7.79 11.62-7.76 18.62l0.66 153.76c0.23 53.1 64.23 79.77 102.09 42.55l492.54-484.14c10.29-10.11 10.36-26.67 0.16-36.86l-118.78-118.76c-10.07-10.08-26.38-10.15-36.54-0.16",
    fill: "#fff",
    strokeLinecap: "round",
    paintOrder: "stroke"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.32619 0 0 -.32619 78.858 -56.828)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1921.7 -4514.3)",
    d: "m1894.8 4296.4 210.2 210.21c4.89 4.89 7.63 11.54 7.6 18.46l-0.66 154.79c-0.22 53.35-64.73 79.91-102.46 42.18l-271.18-271.18c-10.2-10.2-10.13-26.76 0.16-36.87l119.79-117.74c10.16-9.99 26.47-9.92 36.55 0.15",
    fill: "#fff",
    strokeLinecap: "round",
    paintOrder: "stroke"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.32619 0 0 -.32619 105.3 102.32)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-2002.7 -4170.7)",
    d: "m1892.8 4170.5v-133.53c0-53.47 64.65-80.25 102.46-42.44l109.83 109.83c4.86 4.86 7.6 11.46 7.6 18.35v215.78c0 23.12-27.96 34.7-44.31 18.35l-167.98-167.98c-4.86-4.87-7.6-11.47-7.6-18.36m0 144.21v-133.53c0-53.47 64.65-80.25 102.46-42.44l109.83 109.83c4.86 4.86 7.6 11.46 7.6 18.35v215.78c0 23.12-27.96 34.7-44.31 18.35l-167.98-167.98c-4.86-4.87-7.6-11.47-7.6-18.36",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.32619 0 0 -.32619 -118.73 101.45)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1316 -4172.9)",
    d: "m1206.1 4342.8v-220.12c0-6.88 2.73-13.48 7.6-18.35l109.83-109.83c37.81-37.81 102.46-11.03 102.46 42.44l-0.01 140.75c0 6.96-2.79 13.63-7.76 18.51l-167.97 165.11c-16.41 16.14-44.15 4.51-44.15-18.51m0 142.08v-220.12c0-6.88 2.73-13.48 7.6-18.35l109.83-109.83c37.81-37.81 102.46-11.03 102.46 42.44l-0.01 140.75c0 6.96-2.79 13.63-7.76 18.51l-167.97 165.11c-16.41 16.14-44.15 4.51-44.15-18.51",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhite);
export default __webpack_public_path__ + "static/media/IconWhite.c6f6dd07605dc169aaaf5e92ae25c0a1.svg";
export { ForwardRef as ReactComponent };